import { MbscModule } from '@mobiscroll/angular';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpModule } from '@angular/http';
import { HttpClientModule,HTTP_INTERCEPTORS} from '@angular/common/http';
import { NgModule } from '@angular/core';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { CodemirrorModule } from 'ng2-codemirror';
import { ApiService,AuthenticationService,UserService,MenuService,AlertService,CanDeactivateGuard } from './services/index';
import { DashboardComponent } from './views/dashboard/dashboard.component';
import { HomeComponent } from './views/home/home.component';
import { LoginComponent } from './views/login/index';
import { PageComponent } from './views/page/page.component';
import { DraftComponent } from './views/draft/draft.component';
import { VersionComponent } from './views/version/version.component';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import { AppComponent } from './app.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { ToastrModule } from 'ngx-toastr';
import { FormsModule } from '@angular/forms';
import { TokenInterceptor } from './helpers/index';
import { SpreadSheetsModule } from "@grapecity/spread-sheets-angular";
import {AtomSpinnerModule,PixelSpinnerModule,FingerprintSpinnerModule,
  CirclesToRhumbusesSpinnerModule,BreedingRhombusSpinnerModule,FlowerSpinnerModule,
  FulfillingBouncingCircleSpinnerModule,HalfCircleSpinnerModule,SelfBuildingSquareSpinnerModule
 ,} from 'angular-epic-spinners'

import { AuthGuard } from './helpers/index';
import { NgxSelectModule } from 'ngx-select-ex';

import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown/angular2-multiselect-dropdown';


import { DataTablesModule } from 'angular-datatables';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ModalModule } from 'ngx-bootstrap/modal';
import { ChartsModule } from 'ng2-charts/ng2-charts';
import { DynamicPageDirective,AlertDirective } from './directives/index';
import { DynamicPageComponent } from './helpers/dynamicPage';

// Import routing module
import { AppRoutingModule } from './app.routing';

// Import containers
import {
  FullLayoutComponent,
  SimpleLayoutComponent,
  NoNavLayoutComponent
} from './containers';

const APP_CONTAINERS = [
  FullLayoutComponent,
  SimpleLayoutComponent,
  NoNavLayoutComponent
]

// Import components
import {
  AppAsideComponent,
  AppBreadcrumbsComponent,
  AppBreadcrumbsChildMenusComponent,  
  AppFooterComponent,
  AppHeaderComponent,
  AppHeaderNoNavComponent,
  AppSidebarComponent,
  AppSidebarFooterComponent,
  AppSidebarFormComponent,
  AppSidebarHeaderComponent,
  AppSidebarMinimizerComponent,
  APP_SIDEBAR_NAV
} from './components';

const APP_COMPONENTS = [
  AppAsideComponent,
  AppBreadcrumbsComponent,
  AppBreadcrumbsChildMenusComponent,  
  AppFooterComponent,
  AppHeaderComponent,
  AppHeaderNoNavComponent,
  AppSidebarComponent,
  AppSidebarFooterComponent,
  AppSidebarFormComponent,
  AppSidebarHeaderComponent,
  AppSidebarMinimizerComponent,
  APP_SIDEBAR_NAV
]

// Import directives
import {
  AsideToggleDirective,
  NAV_DROPDOWN_DIRECTIVES,
  ReplaceDirective,
  SIDEBAR_TOGGLE_DIRECTIVES,
  ToggleFullscreenDirective
} from './directives';

const APP_DIRECTIVES = [
  AsideToggleDirective,
  NAV_DROPDOWN_DIRECTIVES,
  ReplaceDirective,
  ToggleFullscreenDirective,
  SIDEBAR_TOGGLE_DIRECTIVES
]

@NgModule({
  imports: [ 
    MbscModule,  
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpModule,
    HttpClientModule,
    ChartsModule,
    CodemirrorModule,
    FormsModule,
    NgxSelectModule,
    HttpModule,
    CodemirrorModule,
    NgxDatatableModule,
    DataTablesModule,
    AngularMultiSelectModule,
    SpreadSheetsModule,
    AtomSpinnerModule,
    PixelSpinnerModule,
    FingerprintSpinnerModule,
    CirclesToRhumbusesSpinnerModule,
    BreedingRhombusSpinnerModule,
    FlowerSpinnerModule,
    FulfillingBouncingCircleSpinnerModule,
    HalfCircleSpinnerModule,
    SelfBuildingSquareSpinnerModule,
    FroalaEditorModule.forRoot(), 
    FroalaViewModule.forRoot(),
    BsDropdownModule.forRoot(),
    TabsModule.forRoot(),
    ToastrModule.forRoot(),
    CarouselModule.forRoot(),
    CollapseModule.forRoot(),
    PaginationModule.forRoot(),
    PopoverModule.forRoot(),
    ProgressbarModule.forRoot(),
    TooltipModule.forRoot(),
    ModalModule.forRoot()
  ],
  declarations: [
    AppComponent,
    DashboardComponent,
    HomeComponent,
    LoginComponent,
    PageComponent ,
    DraftComponent,
    VersionComponent,
    DynamicPageComponent,
    DynamicPageDirective,
    AlertDirective,
    ...APP_CONTAINERS,
    ...APP_COMPONENTS,
    ...APP_DIRECTIVES
  ],
  providers: [
    AuthGuard,
    CanDeactivateGuard,
    UserService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    DynamicPageComponent,
    ApiService,
    MenuService,
    AuthenticationService,
    AlertService,{
    provide: LocationStrategy,
    useClass: HashLocationStrategy
  }],
  bootstrap: [ AppComponent ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts